<template>
    <div>
        <form-data :list="formlist" @getAuth="getAuth" />
    </div>
</template>
<script>
    import './myconedit.less'
    import {addmember} from '@/libs/api'
    import formData from '@/components/form'
    import { getStorage,removeStorage} from '@/libs/utils'
    import params from '@/config/index'

    export default {
        name: 'userlist',
        components: {
            formData
        },
        data() {
            return {
                formlist: [],
                memberid: undefined
            }
        },
        methods:{
            getAuth(data){
                if(data){
                    let userinfo = getStorage('userInfo')
                    let urid = userinfo.urid
                    let token = userinfo.token
                    addmember({memberid:this.memberid,json:JSON.stringify(data),urid:urid,token:token}).then((res)=>{
                        if(res.status==200)
                        {
                            //清空缓存
                            removeStorage('contacts')
                            this.$router.replace({name:'mycontacts'});
                        }
                    })
                }                
            }
        },
        mounted() {
            this.$nextTick(() => {
                //读取缓存
                try{
                    var attrs = getStorage('contacts');
                    if(attrs)
                    {
                        this.formlist = attrs.memberinfos

                    }else{
                        params.publicattrs.forEach((item) => {
                            if (item.type == 6||item.type == 3) {
                                if(typeof(item.options)=='string')
                                {
                                item.options = JSON.parse(item.options);
                                }
                            }
                        })
                        this.formlist.push(...params.publicattrs)
                    }
                }catch(e){
                // console.log(e);
                }
            })
        }
    }
</script>